var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"text-gray-400 font-bold",class:_vm.toggled ? _vm.Icon.ChevronDown : _vm.Icon.ChevronRight,on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }